import { render } from "./ModalFirmaInterventoDetail.vue?vue&type=template&id=badce68e&scoped=true&ts=true"
import script from "./ModalFirmaInterventoDetail.vue?vue&type=script&lang=ts"
export * from "./ModalFirmaInterventoDetail.vue?vue&type=script&lang=ts"

import "./ModalFirmaInterventoDetail.vue?vue&type=style&index=0&id=badce68e&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ambient/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badce68e"]])

export default __exports__